export default function CTASection({ onOpenModal }: { onOpenModal: () => void }) {
  return (
    <section className="py-12 sm:py-16 bg-gradient-to-r from-emerald-600 to-teal-700">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <h2 className="text-xl sm:text-3xl md:text-4xl font-extrabold text-white mb-3 sm:mb-4 leading-tight px-2">
          ¿ESTÁS LISTO PARA DAR EL SALTO?
        </h2>
        <p className="text-sm sm:text-lg text-emerald-100 mb-6 sm:mb-8 max-w-2xl mx-auto px-2">
          Únete a nuestro grupo exclusivo de WhatsApp y asegura tu lugar en el entrenamiento IA-Cash Express. Dentro recibirás los accesos a la clase en vivo, materiales descargables y las estrategias de oro que no comparto en ningún otro lugar
        </p>
        <div className="flex justify-center px-4">
          <button
            onClick={onOpenModal}
            className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-3 bg-white text-emerald-700 px-6 py-4 sm:px-10 sm:py-5 rounded-full text-sm sm:text-lg font-bold uppercase shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer w-full sm:w-auto leading-snug"
          >
            <span className="flex items-center gap-2 whitespace-nowrap">
              👉 RESERVAR MI CUPO
            </span>
            <span className="flex items-center gap-2 whitespace-nowrap">
              PARA LA CLASE EN VIVO
              <i className="ri-whatsapp-line text-lg sm:text-xl"></i>
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}
